import { __assign, __rest } from "tslib";
import React from 'react';
import { components } from 'react-select';
import { Close24 } from '@carbon/icons-react';
export var CustomClearIndicator = function (_a) {
    var props = __rest(_a, []);
    var newProps = __assign(__assign({}, props), { className: props.className });
    return (React.createElement(components.ClearIndicator, __assign({}, newProps),
        React.createElement(Close24, { className: "text-mirage cursor-pointer" })));
};
